export const SUCCESS_STATUS = 3;
export const DISABLE_STATUS_VALUES = [
  '進行中',
];
export const LEGAL_SCRIPT_AUTHOR = 'モチカケ';
export const TODO_STATE = 1;
export const NO_TODO_STATE = 0;
export const STATUS = {
  3: 'complete',
  4: 'archive'
}

export const UN_FULL_FILL_STATUS = 1;
export const DOING_STATUS = 2;
export const COMPLETE_STATUS = 3;
export const ARCHIVE_STATUS = 4;

export const PROPOSAL_STATUS = 0;
export const LS_PROPOSAL_TYPE = 2;
export const USER_ROOT = 1;
export const DATETIME_FORMAT_BEGIN_OF_MINUTE = 'YYYY-MM-DD HH:mm:00';
export const DATETIME_FORMAT_END_OF_MINUTE = 'YYYY-MM-DD HH:mm:59';
export const DOCUMENT_APPROVE_DEFAULT = 2;
export const DOCUMENT_APPROVE_ACCEPT = 1;
export const DOCUMENT_APPROVE_REJECT = 4;

export const FIELD_TYPE_TEXT = 1;
export const FIELD_TYPE_NUMBER = 2;
export const FIELD_TYPE_DROPDOWN = 3;
export const FIELD_TYPE_SELECT = 4;
export const FIELD_TYPE_MULTISELECT = 5;
export const FIELD_TYPE_PHONE = 6;
export const FIELD_TYPE_DATE = 7;
export const FIELD_TYPE_FULL_NAME = 8;
export const FIELD_TYPE_YEAR_OF_ERA = 9;
export const FIELD_TYPE_ANSWER_MAP = 10;
export const LABEL_LOCATION_OPTIONS = [
  {text: '入力欄の上', value: 'top'},
  {text: '入力欄の前', value: 'pre'},
  {text: '入力欄の後', value: 'after'},
  {text: '非表示', value: 'hidden'}
]
export const FIELD_TYPE_TEXTAREA = 11;
export const FIELD_TYPE_AGE = 12;
export const FIELD_TYPE_ADDRESS = 13;
export const FIELD_TYPE_RANGE_DATE = 14;
export const LABEL_LOCATION_PRE = 'pre';
export const LABEL_LOCATION_AFTER = 'after';
export const LABEL_LOCATION_TOP = 'top';
export const TICK_TYPE = [
  {text: '☑', value: 1},
  {text: 'ⓧ', value: 2},
  {text: '〇', value: 3},
  {text: '⬭', value: 4}
];
export const MIN_SIZE = 1;
export const TYPE_WORD_PURE = 'pure';
export const TYPE_WORD_TEMPLATE = 'template';
export const TYPE_PDF = 'pdf';
export const NUMBER_ENTER_TYPE = {
  ENTER_MANUALLY: 1,
  ENTER_BY_CONTROL: 2
}
export const GROUP_TYPE_PARENT = 1;
export const GROUP_TYPE_SUB = 2;
export const GROUP_TYPE_ADMIN = -3;
export const GROUP_TYPE_ADMIN_SUB = -4;
export const GROUP_TYPE_UNCLASSIFIED = 5;
export const GROUP_TYPE_UNCLASSIFIED_SUB = 6;

export const PRIORITIES = {
  1: '高',
  2: '中',
  3: '低',
};

export const MODAL_PRIORITIES = {
  1: '高',
  2: '中',
  3: '低',
};

export const REGEX_JAPANESE = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g

export const META_CREATED_DATE = '作成日';
export const META_MANAGER = '担当者';
export const PUBLISH_ROUTE_ROLE_APPLICATION = [
  'dashboard',
  'settings',
  'auth-change-password',
  'applications',
  'applications-list',
  'applications-detail-id',
  'applications-form-app_id',
  'applications-download-app_id',
  'applications-charge-app_id',
  'document-templates',
  'document-templates-detail',
  'document-templates-id',
  'receipt',
  'settings-company',
];

export const FIELD_TYPE_HTML = 0;
export const FIELD_TYPE_EDITOR = 1;

export const SURVEY_TYPE_TEXT = 1;
export const SURVEY_TYPE_RADIO = 2;
export const SURVEY_TYPE_EXPENSION = 3;
export const SURVEY_TYPE_IMAGE = 4;
export const SURVEY_TYPE_INPUT_TEXT = 5;
